import type { AdminRoleDto, AdminRolesListParams } from '../types/role.types';
import httpClient from '@/core/api/createAxiosHttpClient';
import type { PagedResult } from '@/shared/types/paginated.type';

export const rolesApi = {
  listRoles: async (params: AdminRolesListParams = {}) => {
    const queryParams = new URLSearchParams();
    queryParams.append('page', String(params.page ?? 1));
    if (params.pageSize) queryParams.append('pageSize', String(params.pageSize));
    return httpClient.get<PagedResult<AdminRoleDto>>(`/admin/roles?${queryParams.toString()}`);
  },
};
